import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Api } from './api.service';
import { OptionPayment } from '../entities/index';
import { Log } from '../utils/index';

@Injectable()
export class OptionPaymentService {
  constructor(protected http: Api) {
  }

  @Log('green')
  getSubscriptionOptionPayments(subscription_id: number): Observable<OptionPayment[]> {
    return this.http.get(`subscription/${subscription_id}/options/payments`).map(res => {
      return res.items;
    });
  }

  @Log('green')
  getAccountOptionPayments(user_id: number): Observable<OptionPayment[]> {
    return this.http.get(`user/${user_id}/account-options/payments`).map(res => {
      return res.items;
    });
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/services/option-payment.service.ts